'use client';

import { useTranslations } from 'next-intl';
import CustomLink from 'components/shared/CustomLink';
import { CustomImage } from 'components/shared/custom-image';
import pills from './styles.module.css';
import styles from './InStockCTA.module.css';

const CTA_IMAGE = 'web_v2/why-uh/footer-bg-desktop.png';
const CTA_IMAGE_MOBILE = 'web_v2/why-uh/footer-bg-mobile.png';

export const InStockCTA = () => {
  const t = useTranslations('whyUltrahuman');

  return (
    <section className={styles.ctaSection}>
      <div className={styles.mobileMedia}>
        <CustomImage
          src={CTA_IMAGE_MOBILE}
          alt={t('inStock.imageAlt')}
          fill
          sizes="100vw"
        />
      </div>
      <div className={styles.desktopMedia}>
        {/* Same photo, landscape crop. Only one of the two is ever displayed,
            so both carry the alt rather than one being decorative. */}
        <CustomImage
          src={CTA_IMAGE}
          alt={t('inStock.imageAlt')}
          fill
          sizes="100vw"
        />
      </div>
      <div className={styles.scrim} />
      <div className={styles.content}>
        <div className={styles.copy}>
          <h2 className={styles.title}>
            <span className={styles.titleMuted}>{t('inStock.titleMuted')}</span>
            {t('inStock.title')}
          </h2>
          <p className={styles.body}>{t('inStock.body')}</p>
        </div>
        <div className={pills.ctaRow}>
          <CustomLink
            className={`${pills.pill} ${pills.pillPrimary}`}
            href="/ring/buy"
            data-buttontype="why-uh footer-cta buy"
          >
            {t('inStock.buyCta')}
          </CustomLink>
          <CustomLink
            className={`${pills.pill} ${pills.pillOutline}`}
            href="/ring"
            data-buttontype="why-uh footer-cta learn-more"
          >
            {t('inStock.learnMoreCta')}
          </CustomLink>
        </div>
      </div>
    </section>
  );
};
